/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index'

let exports = {};

//查询服务列表
exports.getServcListByMerchantIdAndMerchantType = function (data, callback) {// 获取服务列表
    api.post('/servc/list/get/by/merchantId/and/merchantType')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// msu 列表
exports.getMsuPagedList = function (postData, callback) {// 获取MSU分页列表
    api.post('/servc/msu/paged/list/get')
    .data(postData)
    .done(callback)
    .go();
};
exports.getMsuListByGoodsIdAndServicerId = function (postData, callback) {// 获取MSU列表
        api.post('/servc/msu/list/get/by/goodsCatId/and/servicerId')
    .data(postData)
    .done(callback)
    .go();
};
exports.getMsuListByGoodsIdAndMerchantIdAndMerchantType = function (postData, callback) {// 获取MSU列表
    api.post('/servc/msu/list/get/by/goodsId/and/merchantId')
    .data(postData)
    .done(callback)
    .go();
};
// msu 列表
exports.getServcGoodsCatRelList = function (postData, callback) {// 根据上下文获取MSU列表
    api.post('/servc/goods/cat/rel/list/get')
    .data(postData)
    .done(callback)
    .go();
};

export default exports;


//////////////////
// WEBPACK FOOTER
// ./src/api/servc.js
// module id = 210
// module chunks = 0